<template>
  <div class="personal">
    <div class="main">
      <div class="portrait">
        <img class="portrait-img" src="https://vanthink.oss-cn-qingdao.aliyuncs.com/ee81f27c956167f0ac039ca5cd4a297f.png" />
        <span>
          {{userInfo.user_name}}
          <!-- <img src="https://vanthink.oss-cn-qingdao.aliyuncs.com/59cf77b5833b55bf5cb8bc2d2ad45ff9.png" /> -->
        </span>
      </div>
      <ul>
        <li>
          <div class="item">
            <img src="https://vanthink.oss-cn-qingdao.aliyuncs.com/cad2ebb36d97e5a4fc186ab212a5c63f.png" />
            <span class="item-name">手&nbsp;&nbsp;机&nbsp;&nbsp;号</span>
            <span class="item-content">{{userInfo.user_phone}}</span>
          </div>
        </li>
        <li>
          <div class="item">
            <img src="https://vanthink.oss-cn-qingdao.aliyuncs.com/d512b60cdd22c753b8c788628d5194f9.png" />
            <span class="item-name">积&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;分</span>
            <span class="item-content">{{userInfo.user_integral}}分</span>
            <span class="item-function" @click="showIntegralDetails">查看详情</span>
          </div>
        </li>
        <li>
          <div class="item">
            <img src="https://vanthink.oss-cn-qingdao.aliyuncs.com/74348316aa307c4c20f3ef31c3b4300a.png" />
            <span class="item-name">登录密码</span>
            <span class="item-content">············</span>
            <span class="item-function" @click="showEditPassword">修改密码</span>
          </div>
        </li>
        <li>
          <div class="item">
            <img src="https://vanthink.oss-cn-qingdao.aliyuncs.com/6ccac81b036c994cc35ceb010a2d4be5.png" />
            <span class="item-name">意见反馈</span>
            <span class="item-function" @click="giveAdvice">去提意见</span>
          </div>
        </li>
      </ul>
      <van-help iconUrl="https://vanthink.oss-cn-qingdao.aliyuncs.com/3bf47743cda234a1a7f4083b8dbad49f.png" class="help" />
    </div>
    <transition-group name="fade">
      <edit-password-dialog
        v-if="isShowEditPassword"
        key="editPassword"
        @close="closeEditPassword"
        @success="closeEditPassword"
      />
      <feedback-dialog
        v-if="isShowFeedback"
        key="feedback"
        @close="isShowFeedback = false"
      />
      <integral-detail-dialog
        v-if="isShowIntegralDetails"
        key="integralDetails"
        @close="isShowIntegralDetails = false"
      />
    </transition-group>
  </div>
</template>

<script>
import api from '@/api/user';
import VanHelp from '@/components/common/Help.vue';
import EditPasswordDialog from './personal/EditPasswordDialog.vue';
import IntegralDetailDialog from './personal/IntegralDetailDialog.vue';
import FeedbackDialog from './personal/FeedbackDialog.vue';

export default {
  components: {
    VanHelp,
    FeedbackDialog,
    IntegralDetailDialog,
    EditPasswordDialog,
  },
  data() {
    return {
      userInfo: {},
      isShowIntegralDetails: false,
      isShowEditPassword: false,
      isShowFeedback: false,
    };
  },
  created() {
    this.getPersonal();
  },
  methods: {
    getPersonal() {
      api.getPersonal().then((data) => {
        this.userInfo = data;
      });
    },
    showEditPassword() {
      this.isShowEditPassword = true;
    },
    giveAdvice() {
      this.isShowFeedback = true;
    },
    showIntegralDetails() {
      this.isShowIntegralDetails = true;
    },
    start(scene) {
      this.$emit('change', {
        scene,
      });
    },
    closeEditPassword() {
      this.isShowEditPassword = false;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/styles/variables.scss';
  .personal {
    position: absolute;
    left: calc(50% - 26vw);
    top: calc(50% - 40vh);
    .main {
      padding: 0 4%;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      box-sizing: border-box;
      position: relative;
      width: 52vw;
      height: 80vh;
      color: #fff;
      border-radius: 20px;
      background: url('https://vanthink.oss-cn-qingdao.aliyuncs.com/78e15b0fe0b2eaf4df6d7fa5dbcd1ca5.png') no-repeat;
      background-size: cover;
      &::before{
        content: '';
        display: table;
      }
      .portrait {
        display: flex;
        flex-direction: column;
        align-items: center;
        &-img {
          width: 16%;
        }
        span {
          margin-top: 2vh;
          font-size: 2.5vh;
          display: flex;
          align-items: center;
          img {
            margin-left: 10px;
            cursor: pointer;
          }
        }
      }
      ul {
        li {
          margin-bottom: 2vh;
          padding: 2%;
          font-size: 2vh;
          border-radius: 10px;
          background-color: #2A2E54;
          .item {
            display: flex;
            align-items: center;
            &-name {
              margin-left: 1%;
              width: 14%;
            }
            &-content {
              padding-left: 4%;
              border-left: 1px solid #fff;
            }
            &-function {
              margin-left: auto;
              cursor: pointer;
              color: #6D6AFF;
              &:hover {
                color: #b9b8ff;
              }
            }
          }
        }
      }
      /deep/ .van-help {
        color: #fff;
        .van-help__item {
          a {
            color: #fff;
            .service {
              img {
                margin-right: 6px;
              }
            }
          }
        }
      }
    }
    .fade-enter-active, .fade-leave-active {
      transition: all 1s;
    }
    .fade-enter, .fade-leave-to {
      opacity: 0;
    }
  }
</style>
